import teamChat from './teamChat.reducer';

const reducer = {
  teamChat,
};

export default reducer;
